type SoundName = 'start' | 'correct' | 'wrong' | 'wind' | 'fall' | 'finish';

export class BalanceAudio {
  private context?: AudioContext;
  private muted = false;
  unlock() { this.context ??= new AudioContext(); void this.context.resume(); }
  toggleMuted() { this.muted = !this.muted; return this.muted; }
  play(name: SoundName) {
    if (this.muted) return;
    this.unlock();
    const context = this.context!;
    const patterns: Record<SoundName, [number, number, OscillatorType]> = {
      start: [330, 660, 'triangle'], correct: [520, 880, 'sine'], wrong: [190, 120, 'sawtooth'],
      wind: [240, 360, 'sine'], fall: [260, 70, 'sawtooth'], finish: [660, 990, 'triangle'],
    };
    const [from, to, type] = patterns[name];
    const oscillator = context.createOscillator(); const gain = context.createGain();
    oscillator.type = type; oscillator.frequency.setValueAtTime(from, context.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(Math.max(40, to), context.currentTime + 0.32);
    gain.gain.setValueAtTime(0.0001, context.currentTime); gain.gain.exponentialRampToValueAtTime(0.13, context.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.34);
    oscillator.connect(gain).connect(context.destination); oscillator.start(); oscillator.stop(context.currentTime + 0.36);
  }
  destroy() { void this.context?.close(); this.context = undefined; }
}
